/* @sravni/react-design-system version 0.2.71 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { SPACE_SIZES } from '../../../constants/spaces.js';
import modules_490d7587 from '../styles/Space.module.less.js';

/**
 * @description Set components spacing
 *
 * @component
 * @example
 * ```jsx
 * <Space size="m">
 *   <span>content</span>
 *   <span>content</span>
 *   <span>content</span>
 * </Space>
 * ```
 */
var Space = React.forwardRef(function (props, ref) {
    var _a;
    var direction = props.direction, size = props.size, align = props.align, justify = props.justify, wrap = props.wrap, inline = props.inline, className = props.className, children = props.children, style = props.style, restProps = __rest(props, ["direction", "size", "align", "justify", "wrap", "inline", "className", "children", "style"]);
    var cx = useStyles(modules_490d7587);
    var classNames = cx(className, 'container', (_a = {},
        _a["direction-".concat(direction)] = direction,
        _a["align-".concat(align)] = align,
        _a["justify-".concat(justify)] = justify,
        _a.wrap = wrap,
        _a.inline = inline,
        _a));
    var elementStyles = __assign({}, style);
    var sizes = React.useMemo(function () {
        if (!size)
            return;
        var results = [0, 0];
        var normalizedSize = Array.isArray(size) ? size : [size, size];
        normalizedSize.forEach(function (g, index) {
            results[index] = g || 0;
        });
        return results;
    }, [size]);
    if (sizes) {
        elementStyles.columnGap = sizes[0];
        elementStyles.rowGap = sizes[1];
    }
    return (React.createElement("div", __assign({ ref: ref, "data-qa": "Space", className: classNames, style: elementStyles }, restProps), children));
});
Space.defaultProps = {
    direction: 'horizontal',
    size: SPACE_SIZES.S0,
    wrap: false,
};

export { Space };
//# sourceMappingURL=Space.js.map
